import moment from 'moment';

const insertLeadingZero = (number) => {
  if (String(number).length < 2) return `0${number}`;
  return number;
};

const getResultTypeLabel = (resultType) => {
  switch (resultType) {
    case 'time':
      return 'мин.';
    case 'reps':
      return 'повт.';
    case 'weight':
      return 'кг.';
    default:
      return '';
  }
};

class WorkoutResultBase {
  static formatTimeResult(result) {
    const duration = moment.duration(result, 'seconds');
    const minutes = insertLeadingZero(duration.minutes());
    const seconds = insertLeadingZero(duration.seconds());
    return `${minutes}:${seconds}`;
  }

  static getResultLabel(workoutResult) {
    const { resultType } = workoutResult;
    let { result } = workoutResult;
    if (resultType === 'time') {
      result = WorkoutResultBase.formatTimeResult(result);
    }

    return `${result} ${getResultTypeLabel(resultType)}`;
  }
}

export default WorkoutResultBase;
